import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import {
  GetWhiteListCustomersRequest,
  GetWhiteListCustomersResponse,
  GetWhiteListLoanTemplatesResponse,
  RegisterWhiteListCustomerRequest,
} from "../models/loanTemplateWhiteList.model";
import { ApiBaseUrl, LoanTemplateWhiteList } from "../config/config";

export const GetWhiteListCustomers = async (
  data: GetWhiteListCustomersRequest
): Promise<ApiResultModel<GetWhiteListCustomersResponse[]>> => {
  return await Axios.post<ApiResultModel<GetWhiteListCustomersResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + LoanTemplateWhiteList + "/GetWhiteListCustomers",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetWhiteListLoanTemplates = (): Promise<GetWhiteListLoanTemplatesResponse[]> => {
  return Axios.get<ApiResultModel<GetWhiteListLoanTemplatesResponse[]>>(
    ApiBaseUrl + LoanTemplateWhiteList + "/GetWhiteListLoanTemplates"
  ).then((result) => {
    return result.data.data;
  });
};

export const RegisterWhiteListCustomer = async (
  data: RegisterWhiteListCustomerRequest
): Promise<boolean> => {
  const formData = new FormData();
  formData.append("companyName", data.companyName!);
  formData.append("customerFirstName", data.customerFirstName!);
  formData.append("customerLastName", data.customerLastName!);
  formData.append("customerNationalCode", data.customerNationalCode!);
  formData.append("loanTemplateId", data.loanTemplateId!.toString());
  formData.append(
    "monthlyRepaymentPower",
    data.monthlyRepaymentPower!.toString()
  );
  formData.append("file", data.file!);
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + LoanTemplateWhiteList + "/RegisterWhiteListCustomer",
    formData
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteWhiteListCustomer = async (data: {
  id: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + LoanTemplateWhiteList + "/DeleteWhiteListCustomer",
    data
  ).then((result) => {
    return result.data.data;
  });
};
